import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/atoms';
import { routes } from '@/lib/constants';
import { Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router';

interface UpgradePlanModalProps {
  open: boolean;
  title?: string;
  description?: string;
  onOpenChange: (open: boolean) => void;
}

export function UpgradePlanModal({
  open,
  onOpenChange,
  title = 'This is not included in your plan',
  description = 'Upgrade your subscription to use this feature. You can compare plans and pick the one that fits how you sell.',
}: UpgradePlanModalProps) {
  const navigate = useNavigate();

  const goToPlans = () => {
    onOpenChange(false);
    navigate(`${routes.settings}?tab=subscription&view=plans`);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="gap-0 overflow-hidden p-0 sm:max-w-md">
        <div className="flex flex-col items-center gap-4 px-6 pt-8 pb-6 text-center">
          <div className="flex size-14 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Sparkles className="size-6" />
          </div>
          <DialogTitle className="text-xl font-semibold text-foreground">
            {title}
          </DialogTitle>
          <DialogDescription className="max-w-sm text-sm leading-6 text-muted-foreground">
            {description}
          </DialogDescription>
        </div>
        <div className="flex flex-col gap-3 border-t bg-muted/30 px-6 py-5">
          <Button type="button" className="w-full" onClick={goToPlans}>
            Upgrade plan
          </Button>
          <Button
            type="button"
            variant="outline"
            className="w-full"
            onClick={goToPlans}
          >
            See all plans
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
